<template>
  <v-form ref="form" @submit="Confirm" lazy-validation>
    <v-card class="elevation-12">
      <v-card-title primary-title class="primary">
        <div class="headline white--text">Resend Sign Up</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          autocomplete="username"
          prepend-icon="person"
          name="username"
          label="Username"
          :rules="nameRules"
          :disabled="loading"
          v-model="user.username"
          type="text">
        </v-text-field>
        <v-text-field
          prepend-icon="vpn_key"
          name="code"
          label="Verification Code"
          :rules="codeRules"
          :disabled="loading"
          v-model="user.code"
          type="text">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="Confirm"
          :loading="loading"
          type="submit">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConfirmSignUp',
  data() {
    return {
      loading: false,
      nameRules: [
        v => !!v || 'Username ist ein Pflichtfeld',
        v => (v && v.length <= 10) || 'Username must be less than 10 characters',
      ],
      codeRules: [
        v => !!v || 'Verification Code ist ein Pflichtfeld',
      ],
      user: {
        username: null,
        code: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
  methods: {
    ...mapActions({
      resendSignUp: 'auth/resendSignUp',
      showSnackbar: 'snackbar/success',
    }),
    Confirm(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.resendSignUp(this.user)
          .then((res) => {
            console.log(res);
            this.loading = false;
            if (res) {
              this.showSnackbar('Resent code, check your email and activate your account');
              this.$router.push({ name: 'ConfirmSignUp' });
            }
          });
      }
    },
  },
  mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  },
};
</script>

<style scoped>

</style>
